import fetch_serve from "@/config/request";

// 记录访问次数，访问官网时调用
export function recordVisit() {
  return fetch_serve({
    url: `/api/VisitStatistics/record`,
    method: 'post'
  })
}

// 获取首页统计数据
export function getHomeStatistics() {
  return fetch_serve({
    url: `/api/VisitStatistics/home-stats`,
    method: 'get'
  })
}

// 获取首页内容
export function getHomeData() {
  return fetch_serve({
    url: `/api/DynamicContent/home`,
    method: 'get'
  })
}

// 更新首页内容
// data的传参 data = {"jsonContent": "string"}
export function updateHomeData(data) {
  return fetch_serve({
    url: `/api/DynamicContent/home`,
    method: 'put',
    data
  })
}


